import React, { FC } from 'react'
import Head from 'next/head'
import type { Thing, WithContext } from 'schema-dts'

export type SeoProps = {
  title?: string
  description?: string
  image?: string
  twitter_card?: string
  url?: string
  type?: string
  twitter_account?: string
  isoCode?: string
  robots?: string
  jsonLd?: WithContext<Thing>[]
  applicationName?: string
  canonical?: string
}

const Seo: FC<SeoProps> = (props) => {
  const {
    title = '',
    description = '',
    image = null,
    twitter_card = 'summary_large_image',
    url = '',
    type = 'website',
    twitter_account = null,
    isoCode = 'fr_FR',
    robots = null,
    jsonLd = null,
    applicationName = '',
    canonical = null,
  } = props

  return (
    <Head>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="description" content={description} />

      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={isoCode} />
      <meta property="og:site_name" content={applicationName} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:card" content={twitter_card} />

      {canonical && <link rel="canonical" href={canonical} />}
      {robots && <meta property="robots" content={robots} />}
      {image && <meta property="og:image" content={image} />}
      {image && <meta name="twitter:image" content={image} />}
      {twitter_account && (
        <meta property="twitter:site" content={twitter_account} />
      )}
      {twitter_account && (
        <meta name="twitter:creator" content={twitter_account} />
      )}
      {jsonLd &&
        jsonLd?.map((d, index) => (
          <script
            key={`json-ld-${index}`}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(d) }}
          />
        ))}
    </Head>
  )
}

export default Seo
